import { Box, createStyles } from '@mantine/core';
import { Icon } from '@repo/foundations';
import { memo } from 'react';

const useStyles = createStyles(() => ({
	container: {
		display: 'flex',
		gap: 0,
	},
}));

export const OnboardingStepper = memo(
	({ step, totalSteps }: { step: number; totalSteps: number }) => {
		const { classes } = useStyles();

		return (
			<Box className={classes.container}>
				{Array.from({ length: totalSteps }).map((_, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<Icon
						key={index}
						name="pointFilled"
						fillColor={
							index === step ? 'fill/brand/selected' : 'fill/tertiary/default'
						}
						iconPadding={0}
						iconWidth={16}
						iconHeight={16}
					/>
				))}
			</Box>
		);
	}
);
